import { usePipPlayerStore } from '@/stores/pip-player.store';
import { VideoPlayerProvider } from '@/components/VideoPlayer/VideoPlayerProvider';
import { StreamingMode } from '@/types/streaming';
import { SourceType } from '@/types/source';
import type { FullSource } from '@/types/source';
import { PipPlayerShell } from './components/PipPlayerShell';

interface PipSourcePlayerProps {
    source: FullSource;
}

export function PipSourcePlayer({ source }: PipSourcePlayerProps) {
    const setIsPlaying = usePipPlayerStore((s) => s.setIsPlaying);
    const pauseToken = usePipPlayerStore((s) => s.pauseToken);
    const initialMode =
        source.type === SourceType.CAMERA
            ? StreamingMode.LIVE
            : StreamingMode.VOD;

    return (
        <VideoPlayerProvider
            src={source.src || ''}
            source={source}
            initialMode={initialMode}
            autoPlay
            onPlayingChange={setIsPlaying}
            pauseSignal={pauseToken}
        >
            <PipPlayerShell source={source} />
        </VideoPlayerProvider>
    );
}
